import React, { FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { Card, Divider, Form, Layout, List } from 'antd'
import WeatherLayers from './WeatherLayers/WeatherLayers'
import { backgroundColor } from '../../../theme'
import ToggleOption from './Options/ToggleOption/ToggleOption'
import SelectOption from './Options/SelectOption/SelectOption'
import RACsAndCountiesOption from './Options/RACsAndCountiesOption/RACsAndCountiesOption'

interface IProps {
  collapsed: boolean
  setCollapsed: (value: boolean) => void
}

const { Sider } = Layout

interface Group {
  title: string
  key: string
  options: RightSiderMenuOption[]
}

interface SelectOption {
  value: any
  label: string
}

export interface RightSiderMenuOption {
  key: string
  localStorageKey: string
  title: string
  defaultValue: boolean | any
  options?: SelectOption[]
}

export const options: Group[] = [
  {
    title: 'Map',
    key: 'map',
    options: [
      {
        key: 'map_type',
        localStorageKey: 'assettrak_map_type',
        title: 'Map Type',
        defaultValue: google.maps.MapTypeId.ROADMAP,
        options: [
          {
            label: 'Roadmap',
            value: google.maps.MapTypeId.ROADMAP
          },
          {
            label: 'Satellite',
            value: google.maps.MapTypeId.SATELLITE
          },
          {
            label: 'Terrain',
            value: google.maps.MapTypeId.TERRAIN
          },
          {
            label: 'Hybrid',
            value: google.maps.MapTypeId.HYBRID
          }
        ]
      },
      {
        key: 'icon_type',
        localStorageKey: 'assettrak_icon_type',
        title: 'Icon Type',
        defaultValue: 'icons',
        options: [
          {
            label: 'Icons',
            value: 'icons'
          },
          {
            label: 'Dots',
            value: 'dots'
          }
        ]
      },
      {
        key: 'labels',
        localStorageKey: 'assettrak_labels',
        title: 'Labels',
        defaultValue: true
      },
      {
        key: 'cluster',
        localStorageKey: 'assettrak_cluster',
        title: 'Cluster',
        defaultValue: true
      }
    ]
  },
  {
    title: 'Units',
    key: 'units',
    options: [
      {
        key: 'time-filter',
        localStorageKey: 'assettrak_time_filter',
        title: 'Time Filter',
        defaultValue: '1_day',
        options: [
          {
            label: '1 Hour',
            value: '1_hour'
          },
          {
            label: '1 Day',
            value: '1_day'
          },
          {
            label: '1 Week',
            value: '1_week'
          },
          {
            label: '1 Month',
            value: '1_month'
          }
        ]
      },
      {
        key: 'air',
        localStorageKey: 'assettrak_air_units',
        title: 'Air Units',
        defaultValue: true
      },
      {
        key: 'ambus',
        localStorageKey: 'assettrak_ambus_units',
        title: 'Ambus Units',
        defaultValue: true
      },
      {
        key: 'ground',
        localStorageKey: 'assettrak_ground_units',
        title: 'Ground Units',
        defaultValue: true
      },
      {
        key: 'texas-mask',
        localStorageKey: 'assettrak_texas_mask',
        title: 'Texas Mask',
        defaultValue: true
      }
    ]
  },
  {
    title: 'Layers',
    key: 'layers',
    options: [
      {
        key: 'traffic',
        localStorageKey: 'assettrak_traffic',
        title: 'Traffic',
        defaultValue: false
      },
      {
        key: 'drive-texas',
        localStorageKey: 'assettrak_drive_texas',
        title: 'Drive Texas',
        defaultValue: true
      },
      {
        key: 'msats',
        localStorageKey: 'assettrak_msats',
        title: 'MSATs',
        defaultValue: false
      },
      {
        key: 'ems-stations',
        localStorageKey: 'assettrak_ems_stations',
        title: 'EMS Stations',
        defaultValue: false
      }
    ]
  }
]

const RightSider: FunctionComponent<any> = (props: IProps) => {
  const { collapsed, setCollapsed } = props

  return (
    <Sider
      css={css`
        background-color: ${backgroundColor} !important;
        height: 100vh;
        overflow: auto;
      `}
      trigger={null}
      collapsible={true}
      collapsed={collapsed}
      collapsedWidth={0}
      onCollapse={(value) => setCollapsed(value)}
      width={400}
    >
      <Card>
        <Form layout={'vertical'} size={'small'}>
          {options.map((group: Group) => (
            <div key={group.key}>
              <Divider orientation={'left'}>{group.title}</Divider>
              <Card>
                <List>
                  {group.options.map((option: RightSiderMenuOption) =>
                    option.options ? (
                      <SelectOption
                        key={option.key}
                        localStorageKey={option.localStorageKey}
                        title={option.title}
                        defaultValue={option.defaultValue}
                        options={option.options}
                      />
                    ) : (
                      <ToggleOption
                        key={option.key}
                        localStorageKey={option.localStorageKey}
                        title={option.title}
                        defaultValue={option.defaultValue}
                      />
                    )
                  )}
                </List>
              </Card>
            </div>
          ))}
          <Divider orientation="left">Weather</Divider>
          <WeatherLayers />
          <RACsAndCountiesOption />
        </Form>
      </Card>
    </Sider>
  )
}

export default RightSider
